import { render, staticRenderFns } from "./CellRendererRole.vue?vue&type=template&id=c88bc348&scoped=true&"
import script from "./CellRendererRole.vue?vue&type=script&lang=js&"
export * from "./CellRendererRole.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererRole.vue?vue&type=style&index=0&id=c88bc348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88bc348",
  null
  
)

export default component.exports